<template>
  <section>
    <v-data-table
      class="document-table mb-4"
      :headers="headers"
      :items="documents"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <td
          @click.stop="onClickfile(props.item)"
        >
          <v-layout row align-center>
            <v-icon class="mr-3">
              {{ fileStateIcon(props.item.mime_type) }}
            </v-icon>
            <v-layout column>
              <span class="caption grey--text text--darken-1">
                {{ fileStateName(props.item.mime_type) }}
              </span>
              <highlighter
                class="body-2"
                :searchWords="keywords"
                :textToHighlight="props.item.document_type.name"
                autoEscape
                highlightClassName="highlight"
              />
            </v-layout>
          </v-layout>
        </td>
        <td
          class="caption text-xs-center" width="200"
          @click.stop="onClickfile(props.item)"
        >
          {{ formatDate(props.item.created_at) }}
        </td>
        <td
          class="caption text-xs-center" width="200"
          @click.stop="onClickfile(props.item)"
        >
          {{ formatDate(props.item.last_modification_at) }}
        </td>
      </template>
    </v-data-table>
    <document-dialog
      v-if="showDocumentDialog"
      :doc="selectedDocument"
      :showDocumentDialog="showDocumentDialog"
      @closeDocumentDialog="closeDocumentDialog"
    />
  </section>
</template>

<script>

import format from 'date-fns/format';
import * as ptLocale from 'date-fns/locale/pt';
import DocumentDialog from '@/components/document/show/DocumentDialog';
import { last } from 'lodash';
import fileStateIcon from '@/mixins/file-state-icon';
import fileStateName from '@/mixins/file-type-name';
import Highlighter from 'vue-highlight-words';

export default {
  name: 'OtherFileList',
  components: {
    DocumentDialog,
    Highlighter,
  },
  data() {
    return {
      fileStateIcon,
      fileStateName,
      headers: [
        {
          text: 'Outros',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Criado',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Última Alteração',
          align: 'center',
          sortable: false,
        },
      ],
      selectedDocument: {},
      showDocumentDialog: false,
    };
  },
  props: {
    documents: {
      default: [],
    },
    searchDocumentString: {
      type: String,
      default: '',
    },
  },
  mounted() {
    if (this.$router.currentRoute.query.documentId) {
      const document = this.documents.find(item =>
        item.id === this.$router.currentRoute.query.documentId);
      this.showDocument(document);
    }
  },
  methods: {
    formatDate(date) {
      if (date === new Date()) {
        return 'Hoje';
      }
      return format(date, 'DD [de] MMMM [de] YYYY', { locale: ptLocale });
    },
    onClickfile(doc) {
      if (doc.mime_type === 'audio/mpeg' ||
        doc.mime_type === 'application/mp3' ||
        doc.mime_type === 'image/png' ||
        doc.mime_type === 'image/jpg'
      ) {
        this.showDocument(doc);
      } else {
        this.downloadFile(last(doc.document_versions).file);
      }
    },
    showDocument(doc) {
      this.selectedDocument = doc;
      this.showDocumentDialog = true;
    },
    downloadFile(url) {
      const a = document.createElement('a');
      a.href = url;
      a.setAttribute('download', this.selectedDocument.docflow_number);
      a.click();
    },
    closeDocumentDialog() {
      this.showDocumentDialog = false;
    },
  },
  computed: {
    keywords() {
      return this.searchDocumentString.split(' ');
    },
  },
};
</script>

<style scoped>
  td {
    cursor: pointer;
  }
  .highlight {
    background-color: rgba(255, 226, 0, 0.3);
  }
</style>



// WEBPACK FOOTER //
// src/components/document/list/OtherFileList.vue